export default {
  trackingNumber: {
    english: "Tracking Number",
    spanish: "Número de seguimiento"
  },
  invoiceNumber: {
    english: "Invoice Number",
    spanish: "Número de factura"
  },
  shippingDate: {
    english: "Shipping Date",
    spanish: "Fecha de envío"
  },
  carrier: {
    english: "Carrier",
    spanish: "Portador"
  },
  tracking: {
    english: "Tracking",
    spanish: "Seguimiento"
  },
  trackingList: {
    english: "Tracking List",
    spanish: "Lista de seguimiento"
  },
  orders: {
    english: "Orders",
    spanish: "Órdenes"
  },
  noTrackingNumbers: {
    english: "You have no tracking numbers",
    spanish: "No tienes números de seguimiento"
  },
  viewOrderDetails: {
    english: "View order details",
    spanish: "Ver detalles de la orden"
  },
  trackOrder: {
    english: "Track order",
    spanish: "Rastrear orden"
  },
  loadingTrackingInfo: {
    english: "Loading tracking information",
    spanish: "Cargando información de seguimiento"
  }
};
